module.exports = __webpack_public_path__ + "img/disabled-calendar-icon.730335d5.svg";